import paris2024 from './paris2024.json';

import common from './common';
import overview from './overview';
import alibaba from './alibaba';
import kubernetes from './kubernetes';

export default [paris2024, ...common, ...overview, ...alibaba, ...kubernetes];
